import { jsx as r, jsxs as b } from "react/jsx-runtime";
import { BadgeMode as l } from "./Badge.types.js";
import { c as v } from "../../index-Cu0xwYjD.js";
import { propagateTestid as p } from "../../utils/helpers.js";
const u = "ids-badge--base-v501", m = "ids-badge--pill-v501", f = "ids-badge--success-v501", h = "ids-badge--warning-v501", k = "ids-badge--danger-v501", N = "ids-badge--info-v501", w = "ids-badge--positive-v501", x = "ids-badge--negative-v501", B = "ids-badge-v501", M = "ids-badge--host-v501", s = {
  base: u,
  pill: m,
  success: f,
  warning: h,
  danger: k,
  info: N,
  positive: w,
  negative: x,
  "background-default": "ids-badge--background-default-v501",
  "background-alt": "ids-badge--background-alt-v501",
  badge: B,
  "ids-icon": "ids-icon-v501",
  host: M
}, t = ({
  children: i,
  mode: o = "background-default",
  pill: n,
  className: g,
  host: a,
  ...e
}) => {
  const c = {
    [s.badge]: !0,
    [s.base]: !0,
    [s[o]]: !0,
    [s.pill]: n
  }, d = /* @__PURE__ */ r("span", { className: v(c, g), ...e, children: i });
  return a ? /* @__PURE__ */ b(
    "div",
    {
      className: s.host,
      "data-testid": p(e["data-testid"], "host"),
      children: [
        a,
        d
      ]
    }
  ) : d;
};
t.displayName = "IressBadge";
t.Mode = l;
export {
  t as IressBadge
};
